import React, {useState, useEffect, useRef} from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  Typography,
  Chip,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import {Info} from '@mui/icons-material';
import templateKeys from '../../config/templateKeys.json';

const TypeKeySelector = ({
  value,
  onChange,
  error,
  helperText,
  category,
  disabled = false,
  readOnly = false,
  onCategoryChange,
}) => {
  const [availableKeys, setAvailableKeys] = useState([]);
  const [categoryInfo, setCategoryInfo] = useState(null);
  const initialAutoSelectDone = useRef(false); // Add ref to track auto-select

  const prevCategoryRef = useRef(null);

   useEffect(() => {
    if (category && templateKeys[category]) {
      const info = templateKeys[category];
      setCategoryInfo(info);
      setAvailableKeys(Object.keys(info.keys));

      const categoryChanged =
        prevCategoryRef.current !== null &&
        prevCategoryRef.current !== category;
      prevCategoryRef.current = category;

      if (categoryChanged) {
        initialAutoSelectDone.current = false;
      }

      if (
        (!value || categoryChanged) &&
        info.defaultKey &&
        !initialAutoSelectDone.current
      ) {
        initialAutoSelectDone.current = true;
        setTimeout(() => {
          onChange(info.defaultKey);
        }, 0);
      }
    } else {
      setCategoryInfo(null);
      setAvailableKeys([]);
      prevCategoryRef.current = null;
      initialAutoSelectDone.current = false;
    }
  }, [category]);

  return (
    <Box>
      <FormControl fullWidth error={error} size="small">
        <InputLabel required>Template Type Key *</InputLabel>
        <Select
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          label="Template Type Key *"
          disabled={disabled || !category || availableKeys.length === 0}
          readOnly={readOnly}
          renderValue={selected => (
            <Box display="flex" alignItems="center" gap={1}>
              <Chip
                label={category || 'select category'}
                size="small"
                color="info"
                variant="outlined"
                sx={{height: 20, fontSize: '0.7rem'}}
              />
              <Typography variant="caption" sx={{mx: 0.5}}>
                :
              </Typography>
              <Typography variant="body2" fontWeight="bold">
                {selected}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {/* ({getKeyDisplayName(selected)}) */}
              </Typography>
            </Box>
          )}>
          {!category ? (
            <MenuItem disabled>
              <Box display="flex" alignItems="center" gap={1}>
                <Info fontSize="small" color="info" />
                <span>Select a category first</span>
              </Box>
            </MenuItem>
          ) : availableKeys.length === 0 ? (
            <MenuItem disabled>
              <Box>
                <Typography variant="body2">No keys available</Typography>
                <Typography variant="caption" color="textSecondary">
                  No template keys defined for {category}
                </Typography>
              </Box>
            </MenuItem>
          ) : (
            availableKeys.map(key => (
              <MenuItem key={key} value={key}>
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    {key}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {categoryInfo?.keys[key]}
                  </Typography>
                </Box>
              </MenuItem>
            ))
          )}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default TypeKeySelector;
